
import { AccountContext } from "../../context/AccountContext";
import TransactionService from "../../api/services/TransactionService";
import ModalRootComponent from "./ModalRootComponent";
import CTAButtonComponent from "../CTAButtonComponent";
import InputComponent from "../InputComponent";
import { toast } from "react-toastify";
import { useState, useContext } from "react";

let WithdrawalComponent = ({ setIsModalActive }) => {
    let { stashBalance } = useContext(AccountContext);
    let [amount, setAmount] = useState(0);
    let [errorMsg , setErrorMsg] = useState("");
    let {investor, fetchProfile} = useContext(AccountContext);
    let [isLoading, setIsLoading] = useState(false);
    let handleWithdraw = async () => {
        if(isLoading == true){
            return
        }
        setIsLoading(true);
        if(!amount ){
            return toast.error("₦0 is a money figure neither the rich nor poor want to see in their bank account. Do put in some money figures₦₦₦.");
        }
        if(amount < 1000){
            return toast.error("minimum withdrawal amount is ₦1000");
        }
        if(amount > 1000){
            console.log("Come on!, you are leaving with all that?");
            toast.success("Come on!, you are leaving with all that?");
        }
        let funding = await TransactionService.withdraw({
            amount : amount,
            name : investor.name,
            investorId : investor.id,
            userId : investor.userId
        })


        if(funding.type == "success"){
            toast.success("Money heading your way to your account.")
        }
        else if(funding.type == "error"){
            if(!funding.message){
                toast.error("There seems to be problem somewhere. No worries we are on top of it.")
            }
            else toast.error(funding.message);
        }
        setIsLoading(false);
        console.log(funding);
    }
    let handleAmount = (e) => {
        setAmount(e.target.value);

        if(amount > 5000){
            setErrorMsg("Come on!, you are leaving with all that?");
        }
        else{
            setErrorMsg("");
        }
    }
    return <ModalRootComponent
            children={
                <div className="z20 mulish-font rounded-2xl self-center p-6 pt-9 bg-white">
                    <div onClick={() => setIsModalActive(false)} className="hover:cursor-pointer text-rouzo-text-color-2 font-medium text-xl">
                        <p>{'x'} close</p>
                    </div>
                    <div className="mb-6">
                        <p className="text-rouzo-text-color-2 font-bold text-[32px] mb-6">Withdraw funds</p>
                        <div>
                            <p className="text-rouzo-text-color-2 font-medium text-[24px] mb-6">How much do you want withdraw?</p>
                            <InputComponent onChange={(e) => handleAmount(e)} type="number" placeholder="₦ 100000"></InputComponent>
                        </div>
                    </div>
                    <div className="text-right flex justify-end ">
                        <div >
                            <CTAButtonComponent isLoading={true} onClick={() => handleWithdraw()} text={"Withdraw"}></CTAButtonComponent>
                        </div>
                    </div>
                </div>
            }
        >

        </ModalRootComponent>
}


export default WithdrawalComponent;